import 'react-tagsinput/react-tagsinput.css'

export { default } from 'react-tagsinput'



// WEBPACK FOOTER //
// ./src/components/form/tagsinput/index.js